import { ref } from 'vue';

const getNotifications = () => {
    const notifications_error = ref(null);
    const notifications = ref(null);
    
    const loadNotifications = async (monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others', monitor_others]);
        params.push(['view_locations', view_locations]);

        try {
            let data = await fetch("/api/notifications?" + new URLSearchParams(params));

            if (!data.ok) {
                throw Error("Can't load data");
            }
            //console.log('gets here', data);
            notifications.value = await data.json();

        } catch (err) {
            notifications_error.value = err.message;
        }
    };

    const putDenyRevokeRequest = async (notification) => {

        let contextData = JSON.parse(notification.contextdata);

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'notification_id': notification.id}),
        };

        try {
            const response = await fetch('/api/vacations/' + contextData.absence_id + '/denyrevoke', requestOptions);

            if (!response.ok) {
                notifications_error.value = response.status + ' - ' + response.statusText;
            }
            const data = await response.json();

        } catch (err) {
            notifications_error.value = err.message;
            console.log(err.message);
        }
    };

    const putConfirmRevokeRequest = async (notification) => {

        let contextData = JSON.parse(notification.contextdata);

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'notification_id': notification.id}),
        };

        try {
            const response = await fetch('/api/vacations/' + contextData.absence_id + '/confirmrevoke', requestOptions);
            //console.log(requestOptions);
            if (!response.ok) {
                notifications_error.value = await response.json();
                console.log(notifications_error.value);
            }
            //const data = await response.json();

        } catch (err) {
            notifications_error.value = err.message;
            console.log(err.message);
        }
    };

    const putAcknowledgeNotification = async (notification) => {

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            //body: JSON.stringify(expiredQualification)
        };

        try {
            const response = await fetch('/api/notifications/' + notification.id + '/acknowledge', requestOptions);
            console.log(requestOptions);
            console.log(notification.id);
            if (!response.ok) {
                //console.log(response.status + ' - ' + response.statusText);
                notifications_error.value = response.status + ' - ' + response.statusText;
                console.log(notifications_error.value);
            }
            const data = await response.text();

        } catch (err) {
            notifications_error.value = err.message;
            console.log(err.message);
        }
    };

    return { notifications, notifications_error, loadNotifications, putDenyRevokeRequest, putConfirmRevokeRequest, putAcknowledgeNotification };
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getNotifications;
